<template>
  <smart-banner
    :bg-color="bgColor"
    direction="center"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    kicker-align="center"
    title-color="#3b3b3b"
    title-size="h2"
    title-weight="400"
    title-align="center"
    text-color="#43515A"
    text-size="md"
    text-weight="400"
    text-align="center"
    :has-button="true"
    :has-image="false"
    :center-items="true"
    :reduce-width="true"
    :has-video="false"
  >
    <template #kicker>
      <slot name="tertiary-kicker" />
    </template>
    <template #title>
      <slot name="tertiary-title" />
    </template>
    <template #text>
      <slot name="tertiary-text" />
    </template>
    <template #button>
      <slot name="tertiary-buttons" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-tertiary',
  components: {
    SmartBanner,
  },
  props: {
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
  }
}
</script>
